import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';
import './Forums.css';

const Forums = () => {
  const { courseId } = useParams();
  const { user } = useAuth();
  const [questions, setQuestions] = useState([]);
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [newQuestion, setNewQuestion] = useState({ title: '', content: '' });

  useEffect(() => {
    fetchData();
  }, [courseId]);

  const fetchData = async () => {
    try {
      const [questionsRes, courseRes] = await Promise.all([
        api.get(`/forums/questions/course/${courseId}`),
        api.get(`/courses/${courseId}`),
      ]);
      setQuestions(questionsRes.data);
      setCourse(courseRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitQuestion = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/forums/questions/course/${courseId}`, newQuestion);
      setNewQuestion({ title: '', content: '' });
      setShowForm(false);
      fetchData();
    } catch (error) {
      console.error('Error posting question:', error);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="page forums-page">
      <div className="container">
        <div className="forums-header">
          <div>
            <h1>Q&A - {course?.title}</h1>
            <p>{questions.length} questions</p>
          </div>
          {user && (
            <button onClick={() => setShowForm(!showForm)} className="btn-primary">
              Ask Question
            </button>
          )}
        </div>

        {showForm && (
          <div className="question-form-card">
            <h3>Ask a Question</h3>
            <form onSubmit={handleSubmitQuestion}>
              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={newQuestion.title}
                  onChange={(e) => setNewQuestion({ ...newQuestion, title: e.target.value })}
                  placeholder="What's your question about?"
                  required
                />
              </div>
              <div className="form-group">
                <label>Details</label>
                <textarea
                  value={newQuestion.content}
                  onChange={(e) => setNewQuestion({ ...newQuestion, content: e.target.value })}
                  placeholder="Provide more details about your question..."
                  rows="4"
                  required
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Post Question</button>
                <button type="button" onClick={() => setShowForm(false)} className="btn-secondary">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        {questions.length === 0 ? (
          <div className="empty-state">
            <p>No questions yet. Be the first to ask!</p>
          </div>
        ) : (
          <div className="questions-list">
            {questions.map(question => (
              <Link
                key={question.id}
                to={`/questions/${question.id}`}
                className="question-card"
              >
                <div className="question-stats">
                  <div className="stat">
                    <span className="number">{question.answer_count}</span>
                    <span className="label">answers</span>
                  </div>
                  <div className="stat">
                    <span className="number">{question.views}</span>
                    <span className="label">views</span>
                  </div>
                </div>
                <div className="question-content">
                  <h3>{question.title}</h3>
                  <p>{question.content.substring(0, 150)}...</p>
                  <div className="question-meta">
                    <span className="author">
                      {question.first_name} {question.last_name}
                    </span>
                    <span className="date">
                      {new Date(question.created_at).toLocaleDateString()}
                    </span>
                    {question.is_answered && (
                      <span className="answered-badge">Answered</span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Forums;
